import React, { useCallback, useState } from 'react';
import { useDispatch, useMappedState } from 'redux-react-hook';
import styled from 'styled-components';
import { STRINGS } from 'config';
import { ColumnDiv, Div } from 'styles/elements/div';
import Text from 'styles/blocks/question/text';
import { BubblePulseLoader } from 'styles/blocks/spinner/eTriageSpinner';
import Card from 'styles/blocks/card';
import { confirmCancelProgress } from 'redux/actions/session';
import { getPreviousQuestion, goBack } from 'redux/actions/consultation';
import { BackwardsNavigation } from '../../card/backwardsNavigation';

const { PRODUCT: { PRIMARY_CARE, E_SPECIALIST } } = STRINGS;

const InterstitialContainer = styled(Div)`
  padding: 30px;
`;

const BubbleContainer = styled(Div)`
  justify-content: center;
  margin-top: 100px;
`;

export function TemplateInterstitial({ isClinicalReviewMode, header, product }) {
  const mapState = useCallback(state => ({
    interstitialText: state.consultationReducer.interstitialText,
  }), []);
  const { interstitialText } = useMappedState(mapState);

  const [primaryCareOrESpecialist] = useState(() => product === PRIMARY_CARE || product === E_SPECIALIST);

  const dispatch = useDispatch();

  const prevQuestion = useCallback(() => {
    if (primaryCareOrESpecialist) {
      return dispatch(goBack());
    }
    return dispatch(getPreviousQuestion());
  }, [dispatch, primaryCareOrESpecialist]);

  return (
    <ColumnDiv>
      <Card>
        <BackwardsNavigation onPrevious={prevQuestion} onStartOver={() => dispatch(confirmCancelProgress())} product={product}>
          {isClinicalReviewMode && (
            <Card.Header>QPP - {header}</Card.Header>
          )}
          <Card.Inner>
            <Card.FlexRow>
              <Card.CardContents>
                <InterstitialContainer>
                  <Text>{interstitialText}</Text>
                </InterstitialContainer>
              </Card.CardContents>
            </Card.FlexRow>
            <ColumnDiv>
              <BubbleContainer>
                <BubblePulseLoader />
              </BubbleContainer>
            </ColumnDiv>
          </Card.Inner>
        </BackwardsNavigation>
      </Card>
    </ColumnDiv>
  );
}
